document.addEventListener("DOMContentLoaded", function(){

  const tabs = document.querySelectorAll(".rl-tab");
  const contents = document.querySelectorAll(".rl-tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function(){

      const target = this.getAttribute("data-tab");

      // remove active
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // add active
      this.classList.add("active");
      document.getElementById(target).classList.add("active");

    });
  });

});

document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.rl-tab');
    const contents = document.querySelectorAll('.rl-tab-content');

    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            const targetId = this.getAttribute('data-target');

            // Remove active class from all tabs
            tabs.forEach(t => t.classList.remove('active'));
            // Hide all content areas
            contents.forEach(c => c.classList.remove('active'));

            // Add active class to clicked tab
            this.classList.add('active');
            // Show the specific content
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });
});